import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lib-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent implements OnInit {
  @Input()
  color = 'green';

  @Input()
  showDot = false;

  @Input()
  dotColor;

  constructor() {
  }

  ngOnInit(): void {
  }

}
